export const environment = {
    env_name: 'qa',
    prospektr_sell_backend_base_url: 'https://qa-sell-api.prospektr.ai',
    prospektr_sell_media_url: 'https://media.propmix.io/mlslite/media/GetImageURL?fromApp=PROSPECTOR&ImageID=',
    prospektr_buy_backend_base_url: 'https://qa-prospectorapi.propmix.io',
};
